import React from 'react';
import QueryHelpPageLayout from '../QueryHelpPageLayout';
import QueryPatternCard from '../components/QueryPatternCard';
import QueryCopyButton from '../components/QueryCopyButton';
import {QUERY_HELP_PAGE_INTROS} from '../content/pages';
import {
    PRODUCTION_BUILDING_BLOCKS,
    PRODUCTION_MAINTENANCE_TIPS,
    PRODUCTION_SHOWCASE_QUERY,
    PRODUCTION_TEMPLATE_GROUPS,
    PRODUCTION_WHEN_TO_USE,
} from '../content/productionPatterns';

const ProductionPatternsPage = React.memo(() => (
    <QueryHelpPageLayout
        title="Production patterns"
        intro={QUERY_HELP_PAGE_INTROS.production}
    >
        <section className="query-help-modal__tip-section">
            <h4 className="query-help-modal__section-title">{PRODUCTION_WHEN_TO_USE.title}</h4>
            <p className="query-help-modal__section-intro">{PRODUCTION_WHEN_TO_USE.body}</p>
        </section>

        {PRODUCTION_TEMPLATE_GROUPS.map((group) => (
            <section key={group.id} className="query-help-modal__sample-group">
                <h4 className="query-help-modal__section-title">{group.title}</h4>
                {group.intro ? (
                    <p className="query-help-modal__section-intro">{group.intro}</p>
                ) : null}
                <div className="query-help-modal__sample-list">
                    {group.items.map((item) => (
                        <QueryPatternCard key={item.id} item={item} />
                    ))}
                </div>
            </section>
        ))}

        <section className="query-help-modal__tip-section">
            <div className="query-help-modal__sample-card-header">
                <h4 className="query-help-modal__section-title">{PRODUCTION_SHOWCASE_QUERY.title}</h4>
                <QueryCopyButton query={PRODUCTION_SHOWCASE_QUERY.query} />
            </div>
            <pre className="query-help-modal__query-block">{PRODUCTION_SHOWCASE_QUERY.query}</pre>
            <p className="query-help-modal__section-intro">{PRODUCTION_SHOWCASE_QUERY.description}</p>
        </section>

        <section className="query-help-modal__tip-section">
            <h4 className="query-help-modal__section-title">Building blocks checklist</h4>
            <ul className="query-help-modal__checklist">
                {PRODUCTION_BUILDING_BLOCKS.map((block) => (
                    <li key={block}>{block}</li>
                ))}
            </ul>
        </section>

        <section className="query-help-modal__tip-section">
            <h4 className="query-help-modal__section-title">Maintenance tips</h4>
            <div className="query-help-modal__sample-list">
                {PRODUCTION_MAINTENANCE_TIPS.map((tip) => (
                    <article key={tip.id} className="query-help-modal__tip-card">
                        <h5 className="query-help-modal__tip-card-title">{tip.title}</h5>
                        <p className="query-help-modal__sample-description">{tip.body}</p>
                    </article>
                ))}
            </div>
        </section>
    </QueryHelpPageLayout>
));

export default ProductionPatternsPage;
